import { render, staticRenderFns } from "./SingpassCallback.vue?vue&type=template&id=4b28370e&"
import script from "./SingpassCallback.vue?vue&type=script&lang=js&"
export * from "./SingpassCallback.vue?vue&type=script&lang=js&"
import style0 from "./SingpassCallback.vue?vue&type=style&index=0&id=4b28370e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports